import { render } from "./ModalBalanceAdd.vue?vue&type=template&id=b01da042&scoped=true"
import script from "./ModalBalanceAdd.vue?vue&type=script&lang=js"
export * from "./ModalBalanceAdd.vue?vue&type=script&lang=js"

import "./ModalBalanceAdd.vue?vue&type=style&index=0&id=b01da042&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Tomi\\PhpstormProjects\\frontend-v2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b01da042"]])

export default __exports__